import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthQuery } from '@auth/state/auth.query';
import { AuthUser } from '@auth/state/auth.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {

  user: undefined | AuthUser = undefined;
  is_admin = false;
  userSub!: Subscription;

  constructor(private readonly authQuery: AuthQuery,) { }

  ngOnInit(): void {
    this.userSub = this.authQuery.user$.subscribe( user => {
      this.user = user;
      this.is_admin = this.user?.is_admin === "1" ? true: false;   
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }

}
